import "./styles.less";

import { Button, Col, Row, Typography } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

import { Dayjs } from "dayjs";
import React from "react";
import { useTheme } from "../../../../Styles/ThemeHook";

export const CustomHeader = ({
	month,
	prevMonth,
	nextMonth,
}: {
	month: Dayjs;
	prevMonth?: any;
	nextMonth?: any;
}) => {
	const { theme } = useTheme();
	return (
		<Row
			className={"custom-header"}
			justify={"space-between"}
			align={"middle"}
			style={{ minHeight: 48 }}>
			<Col flex={`${theme.spacing.xxlSpacing}px`}>
				{prevMonth && (
					<Button
						shape="circle"
						size={"small"}
						className={"secondary left"}
						onClick={prevMonth}>
						<LeftOutlined />
					</Button>
				)}
			</Col>
			<Col>
				<Typography>{month.format("MMMM")}</Typography>
			</Col>
			<Col flex={`${theme.spacing.xxlSpacing}px`}>
				{nextMonth && (
					<Button
						shape="circle"
						size={"small"}
						className={"secondary right"}
						onClick={nextMonth}>
						<RightOutlined />
					</Button>
				)}
			</Col>
		</Row>
	);
};
